import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {Budget} from '../../interfaces';
import {ProjectSelectorComponent} from '../../shared/project-selector-component/project-selector-component.component';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'app-merge-budget-dialog',
    templateUrl: './merge-budget-dialog.component.html',
    styleUrls: ['./merge-budget-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogContent,
        ProjectSelectorComponent,
        MatDialogActions,
        MatButtonModule
    ]
})
export class MergeBudgetDialogComponent {

    private selectedBudget: Budget | undefined;

    constructor(public dialogRef: MatDialogRef<MergeBudgetDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { budget: Budget }) {
    }

    onBudgetChange(event) {
        this.selectedBudget = event;
    }

    submit() {
        if (this.selectedBudget) {
            this.dialogRef.close(this.selectedBudget);
        }
    }
}